import { digObject } from '@domain-group/javascript-utils'

export const memberRoles = [
  'account_coordinator',
  'account_manager',
  'account_supervisor',
  'client_success',
  'support_supervisor',
  'template_developer',
  'template_quality_controller',
  'template_supervisor',
] as const

export type MemberRole = typeof memberRoles

export const memberRoleSettings = {
  account_coordinator: {
    label: 'Account Coordinator',
  },
  account_manager: {
    label: 'Account Manager',
  },
  account_supervisor: {
    label: 'Account Supervisor',
  },
  client_success: {
    label: 'Client Success',
  },
  support_supervisor: {
    label: 'Support Supervisor',
  },
  template_developer: {
    label: 'Template Developer',
  },
  template_quality_controller: {
    label: 'Template Quality Controller',
  },
  template_supervisor: {
    label: 'Template Supervisor',
  },
}

export const getMemberRoleSetting = (memberRole: MemberRole, settingKey: 'label') => {
  const value = digObject(memberRoleSettings, `${memberRole}.${settingKey}`)
  return value
}
